/**
 * Common utility functions for frontend
 */

// Local storage helpers
const getLocalStorage = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    return null;
  }
};

const setLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

// Form validation helpers
const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

const validatePhone = (phone) => {
  const re = /^[0-9]{10,15}$/;
  return re.test(phone);
};

// Date formatting
const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

const getCookie = (name) => {
  const cookieString = document.cookie;
  if (cookieString === "") {
    return null;
  }
  const cookies = cookieString.split('; ');
  for (const cookie of cookies) {
    if (cookie.startsWith(name + '=')) {
      const value = cookie.substring(name.length + 1);
      return decodeURIComponent(value);
    }
  }
  return null;
};

const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

const getIndStates = () => {
  return [
    {
      "key": "AN",
      "name": "Andaman and Nicobar Islands"
    },
    {
      "key": "AP",
      "name": "Andhra Pradesh"
    },
    {
      "key": "AR",
      "name": "Arunachal Pradesh"
    },
    {
      "key": "AS",
      "name": "Assam"
    },
    {
      "key": "BR",
      "name": "Bihar"
    },
    {
      "key": "CG",
      "name": "Chandigarh"
    },
    {
      "key": "CH",
      "name": "Chhattisgarh"
    },
    {
      "key": "DH",
      "name": "Dadra and Nagar Haveli"
    },
    {
      "key": "DD",
      "name": "Daman and Diu"
    },
    {
      "key": "DL",
      "name": "Delhi"
    },
    {
      "key": "GA",
      "name": "Goa"
    },
    {
      "key": "GJ",
      "name": "Gujarat"
    },
    {
      "key": "HR",
      "name": "Haryana"
    },
    {
      "key": "HP",
      "name": "Himachal Pradesh"
    },
    {
      "key": "JK",
      "name": "Jammu and Kashmir"
    },
    {
      "key": "JH",
      "name": "Jharkhand"
    },
    {
      "key": "KA",
      "name": "Karnataka"
    },
    {
      "key": "KL",
      "name": "Kerala"
    },
    {
      "key": "LD",
      "name": "Lakshadweep"
    },
    {
      "key": "MP",
      "name": "Madhya Pradesh"
    },
    {
      "key": "MH",
      "name": "Maharashtra"
    },
    {
      "key": "MN",
      "name": "Manipur"
    },
    {
      "key": "ML",
      "name": "Meghalaya"
    },
    {
      "key": "MZ",
      "name": "Mizoram"
    },
    {
      "key": "NL",
      "name": "Nagaland"
    },
    {
      "key": "OR",
      "name": "Odisha"
    },
    {
      "key": "PY",
      "name": "Puducherry"
    },
    {
      "key": "PB",
      "name": "Punjab"
    },
    {
      "key": "RJ",
      "name": "Rajasthan"
    },
    {
      "key": "SK",
      "name": "Sikkim"
    },
    {
      "key": "TN",
      "name": "Tamil Nadu"
    },
    {
      "key": "TS",
      "name": "Telangana"
    },
    {
      "key": "TR",
      "name": "Tripura"
    },
    {
      "key": "UK",
      "name": "Uttar Pradesh"
    },
    {
      "key": "UP",
      "name": "Uttarakhand"
    },
    {
      "key": "WB",
      "name": "West Bengal"
    }
  ];
};

const getCountryCodes = () => {
  return [
    { code: '+91', country: 'India' },
  ];
};

const getUserTypes = () => {
  return [
    { value: 'patient', label: 'Patient' },
    { value: 'doctor', label: 'Doctor' },
    { value: 'clinic', label: 'Clinic' },
    { value: 'hospital', label: 'Hospital' },
  ];
};

const isFileLikeURL = (url) => {
  const parts = url.split('/');
  const lastPart = parts[parts.length - 1];
  return lastPart.includes('.'); // Checks for the presence of a dot, implying an extension
}

const getApiUrl = () => {
  let apiUrl = 'https://varosa.co.in/backend/api';
  if (window.location.hostname === 'localhost') {
    apiUrl = 'http://localhost/varosa/backend/api';
  }else if (window.location.hostname === 'wwtdemo.in') {
    apiUrl = 'https://wwtdemo.in/varosa-app/backend/api';
  }
  return apiUrl;
}
const getBackendUrl = () => {
  let backendUrl = 'https://varosa.co.in/backend';
  if (window.location.hostname === 'localhost') {
    backendUrl = 'http://localhost/varosa/backend';
  }else if (window.location.hostname === 'wwtdemo.in') {
    backendUrl = 'https://wwtdemo.in/varosa-app/backend';
  }
  return backendUrl;
}
const getPublicUrl = () => {
  let publicUrl = 'https://varosa.co.in';
  if (window.location.hostname === 'localhost') {
    publicUrl = 'http://localhost:3000/varosa';
  }else if (window.location.hostname === 'wwtdemo.in') {
    publicUrl = 'https://wwtdemo.in/varosa';
  }
  return publicUrl;
}
const getPublicImgUrl = () => {
  let publicImgUrl = 'https://varosa.co.in/img';
  if (window.location.hostname === 'localhost') {
    publicImgUrl = 'http://localhost:3000/varosa/img';
  }else if (window.location.hostname === 'wwtdemo.in') {
    publicImgUrl = 'https://wwtdemo.in/varosa/img';
  }
  return publicImgUrl;
}

export {
  getLocalStorage,
  setLocalStorage,
  validateEmail,
  validatePhone,
  formatDate,
  getCookie,
  getIndStates,
  calculateAge,
  getCountryCodes,
  getUserTypes,
  isFileLikeURL,
  getApiUrl,
  getBackendUrl,
  getPublicUrl,
  getPublicImgUrl,
};
